import { Query } from '../../../hooks/queries'
import { useContrastQuery } from '../../../hooks/use-contrast-query'
import {
  ApplicationModulesResponse,
  getApplicationModules,
  GetApplicationModulesArgs
} from './get-application-modules'

export function useApplicationModules(
  organizationUuid: string,
  applicationUuid: string
) {
  const { data, isLoading, error } = useContrastQuery<
    GetApplicationModulesArgs,
    ApplicationModulesResponse
  >(
    [Query.APPLICATION_MODULES, organizationUuid, applicationUuid],
    getApplicationModules,
    {
      organizationUuid,
      applicationUuid
    }
  )

  return {
    data: data ? data.applications : [],
    isLoading,
    error
  }
}
